export enum State {
  NORMAL,
  SIDEBAR_OPEN,
}
